import React, { ReactElement } from 'react';
import APNForm from './APNform';
import FCMform from './FCMform';
import { FCMDataType, APNDataType } from './interface';

interface PushSettingsProps {
  APNData?: APNDataType;
  FCMData?: FCMDataType;
}

const PushSettings = (props: PushSettingsProps): ReactElement => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'spaceBetween'
      }}
    >
      <div style={{ marginBottom: '20px' }}>
        <APNForm APNData={props.APNData} />
      </div>
      <div>
        <FCMform FCMData={props.FCMData} />
      </div>
    </div>
  );
};
export default PushSettings;
